import type { User } from '../../models/User';
import type { SupabaseClient } from '@supabase/supabase-js';
import { SupabaseRepository } from '../supabaseRepository/SupabaseRepository.ts';

const selector = `id, auth_id, name, customer_id, created_at, created_by, is_verified, organization_name, user_type, invitation_limit`;

export class UserRepository extends SupabaseRepository<User> {
  constructor(client: SupabaseClient) {
    super('users', selector, client);
  }
}
